'use client';

import React, { useEffect } from 'react';

const scriptSrc =
  '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

export function TrustPilotWidget() {
  const [isScriptLoaded, setIsScriptLoaded] = React.useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;
    script.onload = () => setIsScriptLoaded(true);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      {/*<Head>*/}
      {/*	<Script type="text/javascript" src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"*/}
      {/*	        async/>*/}
      {/*</Head>*/}
      {isScriptLoaded && (
        <div
          className='trustpilot-widget'
          data-locale='en-GB'
          data-template-id='53aa8807dec7e10d38f59f32'
          data-businessunit-id='55a6582b0000ff00058113ab'
          data-style-height='150px'
          data-style-width='100%'
          style={{ width: 120, height: 90 }}
        >
          <a
            href='https://uk.trustpilot.com/review/yay.com'
            target='_blank'
            rel='noopener'
          >
            Trustpilot
          </a>
        </div>
      )}
    </>
  );
}
